import React, {useState} from 'react';
import {Fab,} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsModal from './SettingsModal';

export default function Settings({
  unitOfDistance,
  setUnitOfDistance,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{margin:"1rem"}}>
      <Fab onClick={() => setIsOpen(true)} style={{zIndex:1}}>
        <SettingsIcon />
      </Fab>
      <SettingsModal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        unitOfDistance={unitOfDistance}
        setUnitOfDistance={setUnitOfDistance}
      />
    </div>
  );
}